module.exports = __webpack_public_path__ + "img/invoice.db979614.svg";